import { type Draft } from 'immer'
import { type MonthCalendarResponse } from '../types'

export type ItemRename = {
  /** Which index the id is filed under. A month holds both, keyed apart. */
  kind: 'content' | 'moment'
  name: string
}

/**
 * Puts a new name on one item of the window.
 *
 * The two kinds wear their name under different keys — a moment has a `title`
 * and a piece of content a `name` — so the caller says which it is renaming
 * rather than having this guess from the id.
 *
 * An item that is not in the window is left alone: another month can sit in the
 * cache while this one is being read, and it has nothing to say about it.
 */
export const renameItem =
  (itemId: string, { kind, name }: ItemRename) =>
  (draft: Draft<MonthCalendarResponse>) => {
    if (kind === 'moment') {
      const moment = draft.data.moments.by_id[itemId]
      if (moment !== undefined) moment.title = name
      return draft
    }

    const content = draft.data.content.by_id[itemId]
    if (content !== undefined) content.name = name

    return draft
  }
